import React, { useEffect, useState } from "react";
import { ComponentHeader } from "../modules";
import { IWMURL } from "../redux/config/urlConfig";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { completePickup, getPickup } from "../redux/action/pickups";
import PickupTimeLine from "./PickupTimeLine";
import { useMediaQuery } from "react-responsive";
import { Map, Marker, GoogleApiWrapper, Polyline } from "google-maps-react";
import { ProgressBar } from "react-materialize";
import PickupTimeLineRecyclers from "./PickupTimeLineRecyclers";
import Modal from "react-responsive-modal";

const SinglePickup = () => {
  const { pickup, loading } = useSelector((state) => state.pickups);
  const { id } = useParams();
  const [showDetails, setShowDetails] = useState(true);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [quantity, setQuantity] = useState("");
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width:740px)" });

  useEffect(() => {
    dispatch(getPickup(id));
  }, [dispatch, id]);

  if (loading) return <ProgressBar />;

  return (
    <div className="p-1">
      <div>
        <span className="flex space-between align-center ">
          <ComponentHeader title="Pickup Details" />

          {pickup.noSmartPhone && !pickup.completed && (
            <>
              <button
                className="btn"
                onClick={() => setShowCompleteModal(true)}
              >
                Complete Pickup
              </button>
              <Modal
                open={showCompleteModal}
                onClose={() => {
                  setShowCompleteModal(false);
                  setQuantity("");
                }}
                center
              >
                <div>
                  <h2>Complete Pickup</h2>
                  <p className="mt-1 mb-1">
                    Enter the quantity for this pickup completion.
                  </p>
                  {(() => {
                    // Handle both cases: scraps as array or as object
                    let scrap = null;
                    if (Array.isArray(pickup.scraps)) {
                      // If scraps is an array, find the matching scrap
                      scrap = pickup.scraps.find(
                        (s) => s._id === pickup.scrap?._id
                      );
                    } else if (pickup.scraps && pickup.scrap?._id) {
                      // If scraps is an object, use it directly if it matches
                      scrap = pickup.scraps;
                    }

                    // Get total quantity from scrap.quantity
                    const totalQuantity = scrap?.quantity || 0;

                    // Calculate completed quantity from delivery array
                    const completedQuantity = scrap?.delivery?.reduce(
                      (acc, delivery) => acc + (delivery.quantity || 0),
                      0
                    ) || 0;

                    // Get quantity unit
                    const quantityUnit = scrap?.quantityUnit || pickup.scrap?.quantityUnit || "KG";

                    // Calculate percentage
                    const progressPercentage =
                      totalQuantity > 0
                        ? Math.min((completedQuantity / totalQuantity) * 100, 100)
                        : 0;

                    return (
                      <div className="mt-1 mb-1">
                        <div className="flex space-between align-center mb-1">
                          <span className="small-text">
                            Completed: {completedQuantity} / {totalQuantity} {quantityUnit}
                          </span>
                          <span className="small-text bold">
                            {progressPercentage.toFixed(1)}%
                          </span>
                        </div>
                        <div className="progress-container">
                          <div
                            className="progress-bar"
                            style={{
                              width: `${progressPercentage}%`,
                              backgroundColor: "#6f2da8",
                            }}
                          ></div>
                        </div>
                      </div>
                    );
                  })()}
                  <div className="mt-1 mb-1">
                    <label>Enter Quantity</label>
                    <input
                      type="text"
                      className="browser-default input-style full-width"
                      placeholder="Enter quantity"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      style={{
                        marginTop: "5px",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div className="flex gap-1">
                    <buttonw
                      onClick={() => {
                        dispatch(
                          completePickup(id, {
                            scraps: [{
                              _id: pickup.scrap._id,
                              quantityDelivered: quantity,
                              quantityUnit: pickup.scrap?.quantityUnit,
                            }],
                          }, () => {
                            setShowCompleteModal(false);
                            setQuantity("");
                            dispatch(getPickup(id));
                          })
                        );
                      }}
                      className="modal-button cercle-purple white-text"
                      disabled={!quantity || quantity.trim() === ""}
                    >
                      Complete Pickup
                    </buttonw>
                    <button
                      onClick={() => {
                        setShowCompleteModal(false);
                        setQuantity("");
                      }}
                      style={{
                        backgroundColor: "#ccc",
                      }}
                      className="modal-button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Modal>
            </>
          )}
        </span>

        <div style={{ gap: "1.5rem" }} className="flex flex-wrap mt-1">
          <div style={{}} className="flex column flex-1">
            <div
              className="box flex align-center gap-1 white space-between scrap-card"
              style={{}}
            >
              <div className="flex align-center">
                <img
                  src={`${IWMURL}/scraps/read/image/${pickup.scrap?._id}`}
                  style={{ width: "50px", height: "50px" }}
                  alt="scrap"
                />

                <div className="ml-1">
                  <p
                    className="bold small-text"
                    style={{ textTransform: "uppercase" }}
                  >
                    Scrap Name : {pickup.scrap?.name} - {pickup.scrap?.variant}
                  </p>
                  <p className="bold small-text">
                    {" "}
                    Price: {pickup.currency} {pickup.price} /Kg
                  </p>
                </div>
              </div>
            </div>

            {(() => {
              // Handle both cases: scraps as array or as object
              let scrap = null;
              if (Array.isArray(pickup.scraps)) {
                // If scraps is an array, find the matching scrap
                scrap = pickup.scraps.find(
                  (s) => s._id === pickup.scrap?._id
                );
              } else if (pickup.scraps && pickup.scrap?._id) {
                // If scraps is an object, use it directly if it matches
                scrap = pickup.scraps;
              }

              // Get total quantity from scrap.quantity
              const totalQuantity = scrap?.quantity || 0;

              // Calculate completed quantity from delivery array
              const completedQuantity = scrap?.delivery?.reduce(
                (acc, delivery) => acc + (delivery.quantity || 0),
                0
              ) || 0;

              // Get quantity unit
              const quantityUnit = scrap?.quantityUnit || pickup.scrap?.quantityUnit || "KG";

              // Calculate percentage
              const progressPercentage =
                totalQuantity > 0
                  ? Math.min((completedQuantity / totalQuantity) * 100, 100)
                  : 0;

              // Only show progress bar if there's a total quantity
              if (totalQuantity > 0) {
                return (
                  <div className="box white mt-1 mb-1">
                    <div className="flex gap-1 align-center mb-1">
                      <span class="material-icons cercle-purple-text">trending_up</span>
                      <h6>Quantity Progress</h6>
                    </div>
                    <div className="flex space-between align-center mb-1">
                      <span className="small-text">
                        Completed: {completedQuantity} / {totalQuantity} {quantityUnit}
                      </span>
                      <span className="small-text bold cercle-purple-text">
                        {progressPercentage.toFixed(1)}%
                      </span>
                    </div>
                    <div className="progress-container">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${progressPercentage}%`,
                          backgroundColor: "#6f2da8",
                        }}
                      ></div>
                    </div>
                  </div>
                );
              }
              return null;
            })()}

            <div className="box white">
              <div className="flex gap-1 align-center mb-1">
                <span class="material-icons cercle-purple-text">fmd_good</span>
                <h6>Location Information</h6>
              </div>
              <p
                className="chart-header grey-text"
                style={{ textTransform: "uppercase", marginBottom: "5px" }}
              >
                Pickup Location - {pickup?.pickupLocation?.nickname}
              </p>

              <div className="flex gap-1 align-center mb-1">
                <div className="">
                  <p>{pickup?.pickupLocation?.address}</p>
                </div>
              </div>

              {pickup?.dropLocation?.nickname ? (
                <p
                  className="chart-header grey-text"
                  style={{ textTransform: "uppercase", marginBottom: "5px" }}
                >
                  Drop Location - {pickup?.dropLocation?.nickname}
                </p>
              ) : (
                <p
                  className="chart-header grey-text"
                  style={{ textTransform: "uppercase", marginBottom: "5px" }}
                >
                  Drop Location
                </p>
              )}

              <div className="flex gap-1 align-center">
                <div className="">
                  <p>{pickup?.dropLocation?.address}</p>
                </div>
              </div>
            </div>

            {pickup.assigned && (
              <>
                <div className="box white mt-1">
                  {pickup?.drivers?.map((driver, index) => {
                    return (
                      <div key={index}>
                        <div className="flex align-center space-between flex-wrap">
                          <div className="flex">
                            <img
                              src={`${IWMURL}/account/read/photo/${driver._id}`}
                              alt="driver"
                              style={{
                                width: "50px",
                                height: "50px",
                              }}
                              className="circle"
                            />

                            <div className="ml-1">
                              <p>{driver.name}</p>
                              <p>{driver.phoneNumber} </p>
                            </div>
                          </div>

                          <div
                            className={"flex gap-1" + isMobile ? " mt-1 " : ""}
                          >
                            <a
                              href={`${IWMURL}/organization/read/driver/doc/${driver._id}?type=aadhar`}
                              className="btn-outline-small mr-1"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Aadhar Card
                            </a>
                            <a
                              href={`${IWMURL}/organization/read/driver/doc/${driver._id}?type=drivingLicense`}
                              className="btn-outline-small"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Driving License
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {pickup.assigned && (
              <>
                <div className="box white mt-1">
                  {pickup?.drivers?.map((driver, index) => {
                    return (
                      <div key={index}>
                        <div className="flex align-end space-between flex-wrap">
                          <div className="flex" key={index}>
                            <img
                              src={`${IWMURL}/vehicles/read/image/${pickup?.vehicles[index]?._id}`}
                              alt="driver"
                              style={{
                                width: "50px",
                                height: "50px",
                              }}
                              className="circle"
                            />

                            <div className="ml-1">
                              <p>{pickup?.vehicles[index]?.vehicleNumber}</p>
                              <p>{pickup?.vehicles[index]?.capacity} Tonnes</p>
                            </div>
                          </div>

                          <div
                            className={"flex gap-1" + isMobile ? " mt-1 " : ""}
                          >
                            <a
                              href={`${IWMURL}/vehicles/read/registrationCertificate/${pickup?.vehicles[index]?._id}`}
                              className="btn-outline-small mr-1"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Registration Cert
                            </a>
                            <a
                              href={`${IWMURL}/vehicles/read/pollutionCertificate/${pickup?.vehicles[index]?._id}`}
                              className="btn-outline-small"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Pollution Cert
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          <div
            style={{ gap: "1.5rem" }}
            className="flex column flex-1 full-height"
          >
            <SinglePickupMap pickup={pickup} />
          </div>
        </div>
      </div>
      <div className="mt-2">
        <h6 className="">Timeline</h6>
        {pickup.path === "trader/aggregator-to-recycler" ? (
          <PickupTimeLineRecyclers
            pickup={pickup}
            showDetails={showDetails}
            setShowDetails={setShowDetails}
          />
        ) : (
          <PickupTimeLine
            pickup={pickup}
            showDetails={showDetails}
            setShowDetails={setShowDetails}
          />
        )}
      </div>
    </div>
  );
};

const SinglePickupMap = GoogleApiWrapper({
  apiKey: "AIzaSyDsVU8VuCB3p7REGp24SbXZnkNXHaIKCfo",
})(({ pickup, google }) => {
  const mapRef = React.useRef(null);
  useEffect(() => {
    // Ensure that mapRef and pickup locations are available
    if (mapRef.current && pickup.pickupLocation && pickup.dropLocation) {
      // Create LatLngBounds object to include both pickup and drop locations
      const bounds = new window.google.maps.LatLngBounds();

      // Extend bounds to include pickup and drop locations
      bounds.extend(
        new window.google.maps.LatLng(
          pickup.pickupLocation.latitude + 0.2,
          pickup.pickupLocation.longitude + 0.2
        )
      );
      bounds.extend(
        new window.google.maps.LatLng(
          pickup.dropLocation.latitude,
          pickup.dropLocation.longitude
        )
      );

      // Fit the map to the calculated bounds
      mapRef.current.map.fitBounds(bounds);
    }
  }, [pickup.pickupLocation, pickup.dropLocation]);

  return (
    <div style={{}} className="single-pickup-map">
      <Map
        google={google}
        initialCenter={{
          lat: pickup.pickupLocation?.latitude,
          lng: pickup.pickupLocation?.longitude,
        }}
        center={{
          lat: pickup.pickupLocation?.latitude,
          lng: pickup.pickupLocation?.longitude,
        }}
        containerStyle={{
          position: "relative",
          width: "auto",
          height: "483px",
          // marginTop: "10px",
          borderRadius: "10px",
        }}
        zoom={14}
        ref={mapRef}
        style={{ borderRadius: "10px" }}
      >
        <Marker
          title={"Pickup Location"}
          position={{
            lat: pickup.pickupLocation?.latitude,
            lng: pickup.pickupLocation?.longitude,
          }}
        />
        <Marker
          title={"Drop Location"}
          position={{
            lat: pickup.dropLocation?.latitude,
            lng: pickup.dropLocation?.longitude,
          }}
        />

        <Polyline
          path={[
            {
              lat: pickup.pickupLocation?.latitude,
              lng: pickup.pickupLocation?.longitude,
            },
            {
              lat: pickup.dropLocation?.latitude,
              lng: pickup.dropLocation?.longitude,
            },
          ]}
          options={{
            strokeColor: "#FF0000", // Color of the polyline
            strokeOpacity: 0.8, // Opacity of the line
            strokeWeight: 2, // Thickness of the line
          }}
        />
      </Map>
    </div>
  );
});

export default SinglePickup;
